import React from 'react';
import s from './ModalSubText.scss';

interface Props {}

/** For less emphasized text in modals. e.g. the subtitle */
const ModalSubText: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => {
  return <div className={s['root']}>{children}</div>;
};
ModalSubText.displayName = 'ModalSubText';

export default ModalSubText;
